import React from 'react';
import ConfigurationButtonProperties from "./ConfigurationButtonProperties";
import SettingsIcon from '@mui/icons-material/Settings';
import {Observer} from "mobx-react-lite";
import {useStyles} from './ConfigurationButton.style';
import {Badge, Box, Popover} from '@material-ui/core';
import UpdatePaymentFeeButton from "../UpdatePaymentFeeButton/UpdatePaymentFeeButton";
import Access from "../../Access/AllowAccess/Access";
import AllowAccess from "../../Access/AllowAccess/AllowAccess";
import Button from '../../../ui_components/Button/Button';
import { useNavigate } from 'react-router-dom';
import SendSMSButton from "../SendSMSButton/SendSMSButton";

const ConfigurationButton: React.FC<ConfigurationButtonProperties> = () => {

    const classes = useStyles();
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleGeneralConfigurationOnclick = () => {
        handleClose();
        navigate('/configurations');
    }

    return <Observer>
        {() => (
            <AllowAccess any={[Access.UPDATE_PAYMENT_FEES]}>
                <Badge
                    classes={{ badge: classes.configuration_badge_back_color }}
                    max={99} className={classes.configuration_badge}>
                    <Box onClick={handleClick}>
                        <SettingsIcon />
                    </Box>
                </Badge>
                <Popover
                    id="basic-menu"
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <div className={classes.configuration_area_header}>
                        <span className={classes.header_text}>Configuración</span>
                        <SettingsIcon color="action" />
                    </div>
                    <div className={classes.configuration_area_content}>
                        <ul className={classes.configuration_ul}>
                            <AllowAccess isRootAgency={true}>
                                <li className={classes.configuration_li}>
                                    <Button
                                        text={'Generales'}
                                        fullWidth
                                        onClick={handleGeneralConfigurationOnclick}
                                        startIcon={<SettingsIcon/>}
                                    />
                                </li>
                            </AllowAccess>
                           <li className={classes.configuration_li}>
                               <UpdatePaymentFeeButton />
                           </li>
                            <li className={classes.configuration_li}>
                               <SendSMSButton entityType={"AGENCY"} entityIds={[]} />
                           </li>
                        </ul>
                    </div>
                </Popover>
            </AllowAccess>
        )}
    </Observer>
}

export default ConfigurationButton;
